export default __webpack_public_path__ + "static/media/RoboCode.3d88db52.png";